<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listUserSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="2" xs="12">
        <BaseInput
          :options="usernameInput.options"
          :data="usernameInput.data"
          :listener="usernameInput.listener"
        />
      </CCol>
      <CCol sm="2" xs="12">
        <BaseInput
          :options="addressInput.options"
          :data="addressInput.data"
          :listener="addressInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white;"></label>
          <div style="margin-top: 10px;">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/user-management/new.html')"
            >
              <i class="fa fa-plus"></i>&nbsp;Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          @row-click="rowClickTable($event)"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listUserSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #userName="{item}">
            <td>
              <span class="userName" :key="item.userName" v-c-tooltip.hover="item.userName">{{ item.userName }}</span>
            </td>
          </template>
          <template #fullName="{item}">
            <td>
              <span style="font-weight: 550;">{{ item.fullName || 'N/A' }}</span>
            </td>
          </template>
          <template #phone="{item}">
            <td>
              <span style="font-weight: 550;">{{ item.phone || 'N/A' }}</span>
            </td>
          </template>
          <template #email="{item}">
            <td>
              <span class="userName" :key="item.email" v-c-tooltip.hover="item.email"
                    style="font-weight: 550;">{{ item.email || 'N/A' }}</span>
            </td>
          </template>
          <template #enabled="{item}">
            <td>
                <span v-if="item.enabled == 1" class="dot-custom dot-success">
                Hoạt động
              <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Vô hiệu hóa'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_enabled', item.id, item.userName, item.enabled)"
              />
              </span>
              <span v-else class="dot-custom dot-danger">
                Vô hiệu hóa
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Hoạt động'"
                            v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_enabled', item.id, item.userName, item.enabled)"/>
              </span>
            </td>
          </template>
          <template #role="{item}">
            <td v-if="item.role" class="td-roles">
              <CBadge
                color="light"
                class="mr-1"
              >{{ item.role }}
              </CBadge>
            </td>
            <td class="td-roles" v-else>
              <CBadge color="info" class="mr-1">Chưa gán</CBadge>
            </td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="$router.push(`/user-management/${item.id}/managed-user.html`)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton color="info" variant="outline" class="ml-1"
                         v-c-tooltip.hover="'Đặt lại mật khẩu'" square size="sm"
                         @click=" setupSelectOneAction('reset_password', item.id, item.userName)">
                  <CIcon name="cil-loop-circular"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="
                    setupSelectOneAction('delete_one', item.id, item.userName)
                  "
                >
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: "UsersList",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("reset_password", {
      url: "/users/resetPassword",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "đặt lại mật khẩu",
          "tài khoản",
          that.actionData.model.userSelectedName
        );
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return {id: that.actionData.model.userSelectedId};
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Reset mật khẩu tài khoản " + that.actionData.model.userSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_one", {
      url: "/users/deleteUsers",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "tài khoản",
          that.actionData.model.userSelectedName
        );
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return {id: that.actionData.model.userSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa tài khoản " + that.actionData.model.userSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/users/deleteLsUsers",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các tài khoản", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listUserSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách tài khoản thành công"});
        that.loadDataMainTable();
      },
    });

    actionTypeMapping.set("update_enabled", {
      url: "/users/updateEnableUser",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.userIsEnable == true ? "vô hiệu hóa" : "hoạt động", "tài khoản", that.actionData.model.userSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.userSelectedId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: that.actionData.model.userIsEnable == true ? "Vô hiệu hóa tài khoản thành công" : "Hoạt động tài khoản thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          userSelectedId: null,
          userSelectedName: null,
          userIsEnable: null,
          listUserSelectedId: []
        }
      },
      usernameInput: {
        options: {
          placeholder: "Tên đăng nhập",
          label: 'Tên đăng nhập',
        },
        data: {
          name: "username",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      addressInput: {
        options: {
          placeholder: "Địa chỉ",
          label: 'Địa chỉ'
        },
        data: {
          name: "address",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            // {key: "createDate", label: "Ngày tạo"},
            {key: "userName", label: "Tên đăng nhập"},
            {key: "fullName", label: "Họ tên"},
            {key: "phone", label: "SĐT"},
            {key: "email", label: "Email"},
            {key: "enabled", label: "Trạng thái"},
            {key: "address", label: "Địa chỉ"},
            {key: "role", label: "Chức vụ"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "userName", "fullName", "phone", "email", "enabled", "createDate", "locationName", "role", "action"],
          sorter: true,
          columnFilter: false,
          clickableRows: true,
          hover: true,
          itemsPerPageSelect: {label: " ", values: [10, 15, 20, 50], external: true},
          pageSize: 10,
          tableFilter: {label: "Bộ lọc:", placeholder: "Nhập ký tự cần tìm kiếm", external: false}
        },
        dataSource: {
          url: "/users/listUsers",
          dataSubmit: function () {
            that.actionData.model.listUserSelectedId = [];
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    rowClickTable(value) {
      let targetClick = value.event.target;
      if (value.column === 'action' && ($(targetClick).is("i.fa")) ||
        $(targetClick).is("button") || $(targetClick).is("svg") || $(targetClick).is("path")) {
        return;
      }
      if (value && value.item && value.item.id) {
        if (this.actionData.model.listUserSelectedId.includes(value.item.id)) {
          const index = this.actionData.model.listUserSelectedId.indexOf(value.item.id)
          if (index > -1) { // only splice array when item is found
            this.actionData.model.listUserSelectedId.splice(index, 1); // 2nd parameter means remove one item only
            value.item._classes = 'inactive';
          }
        } else {
          value.item._classes = 'active';
          this.actionData.model.listUserSelectedId.push(value.item.id);
        }
      }
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      let listUserSelectedId = this.actionData.model.listUserSelectedId;
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listUserSelectedId = [];

        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listUserSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listUserSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, userSelectedId, userSelectedName, userIsEnable) {
      let actionData = this.actionData.model;
      actionData.userSelectedId = userSelectedId || null;
      actionData.userSelectedName = userSelectedName || null;
      actionData.userIsEnable = userIsEnable || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    // setupSelectMoreAction: function (actionTypeKey) {
    //   this.$refs.actionModal.setCurrAction(actionTypeKey);
    // }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listUserSelectedId": function (newValue) {
      let that = this;
      if (that.$refs.mainTable.items.length > 0 && newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
        that.$refs.mainTable.items.map(each => each._classes = 'active');
      } else {
        that.actionData.model.selectedAll = false;
        if (newValue.length == 0) {
          that.$refs.mainTable.items.map(each => each._classes = 'inactive');
        }
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}

.userName {
  font-weight: 550;
  white-space: nowrap;
  width: 100px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
